import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import FigmaLogo from 'Shared/images/figma-logo.svg';
import FigmaSmartMenu from '../SmartMenu/FigmaSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';

type Props = {
  children: React.ReactNode;
};

const FigmaLink = ({ children, ...restProps }: Props) => (
  <SmartLinkContainer contentEditable={false}>
    <FigmaSmartMenu logoName={FigmaLogo} {...restProps}>
      <SmartLink {...restProps}>
        <SmartLinkLogo src={FigmaLogo} />
        {children}
      </SmartLink>
    </FigmaSmartMenu>
  </SmartLinkContainer>
);

export default FigmaLink;
